<template>
    <div>
      <Button type="primary" style="margin-right: 6px" :key="index" v-for="(button, index) in systemButtons" :loading="button.loading" :disabled="button.disabled" :size="size" @click="onSystemBtnClick(button)">{{$t(button.label)}}</Button>
      <Button type="primary" style="margin-right: 6px" :key="index" v-if="button.show === undefined ? true : button.show" v-for="(button, index) in customButtons" :loading="button.loading" :disabled="typeof button.disabled === 'boolean' ? button.disabled : (button.disabled && button.disabled())" :size="size" @click="onCustomBtnClick(button)">{{$t(button.label)}}</Button>
      <Button type="primary" style="margin-right: 6px" shape="circle" :loading="button.loading ? button.loading : false" :disabled="button.disabled" :key="index" v-for="(button, index) in primaryButtons" :size="size" @click="onCustomBtnClick(button)">{{$t(button.label)}}</Button>
      <slot name="tips"></slot>
        <Upload ref="upload" :show-upload-list="false" style="display: inline-block;" v-if="uploadButton.show" :action="uploadButton.action" :on-success="uploadButton.onSuccess" :before-upload="uploadButton.beforeUpload">
            <Button type="primary" :loading="uploadButton.loading" style="margin-right: 6px">{{uploadButton.label}}</Button>
        </Upload>
        <slot name="custom"></slot>
    </div>
</template>

<script>
    import {
        tableBtnNames,
        icons
    } from './config';
    export default {
        name: 'mButtons',
        data() {
            return {
                defaultIcon: icons.default
            };
        },
        props: {
            size: {
                type: String,
                default: 'default'
            },
            customButtons: {
                type: Array,
                default() {
                    return [];
                }
            },
            systemButtons: {
                type: Array,
                default() {
                    return [];
                }
            },
            primaryButtons: {
                type: Array,
                default() {
                    return [];
                }
            },
            uploadButton: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        methods: {
            // 系统操作按钮点击事件
            onSystemBtnClick(button) {
                this.$emit('onSystemBtnClick', button);
            },
            // 自定义操作按钮点击事件
            onCustomBtnClick(button) {
                this.$emit('onCustomBtnClick', button);
            },
            // 表头系统按钮图标
            getCurrentIcon(btnName) {
                switch (btnName) {
                    case tableBtnNames.btnAdd:
                        return icons.add;
                    case tableBtnNames.btnEdit:
                        return icons.edit;
                    case tableBtnNames.btnDel:
                        return icons.del;
                    case tableBtnNames.btnImport:
                        return icons.import;
                    case tableBtnNames.btnExport:
                        return icons.export;
                    default:
                        return icons.default;
                }
            }
        }
    };
</script>

<style scoped>

</style>
